import { render, staticRenderFns } from "./AddEditMedication.vue?vue&type=template&id=6553cd78"
import script from "./AddEditMedication.vue?vue&type=script&lang=js"
export * from "./AddEditMedication.vue?vue&type=script&lang=js"
import style0 from "./AddEditMedication.vue?vue&type=style&index=0&id=6553cd78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports